import { render, staticRenderFns } from "./PartnerMenu.vue?vue&type=template&id=013907ac&scoped=true&"
import script from "./PartnerMenu.vue?vue&type=script&lang=js&"
export * from "./PartnerMenu.vue?vue&type=script&lang=js&"
import style0 from "./PartnerMenu.vue?vue&type=style&index=0&id=013907ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013907ac",
  null
  
)

export default component.exports